import { Skeleton } from "components/ui/skeleton";

export default function SkeletonMusicLibrariesTable() {
  return (
    <div className="w-full mb-5 mt-2 border rounded-md p-2 ">
      <table className="w-full">
        <thead className="w-full">
          <tr className="">
            <th>
              <Skeleton className="w-[80px] h-4 rounded-tl-md rounded-tr-md" />
            </th>
            <th>
              <Skeleton className="w-1/2 h-4" />
            </th>
            <th>
              <Skeleton className="w-1/2 h-4" />
            </th>
            <th>
              <Skeleton className="w-1/2 h-4" />
            </th>
            <th>
              <Skeleton className="w-1/2 h-4" />
            </th>
            <th>
              <Skeleton className="rounded-tl-md rounded-tr-md w-1/2 h-4" />
            </th>
          </tr>
        </thead>
        <tbody>
          {[...Array(7)].map((_: any, index: number) => {
            return (
              <tr key={index}>
                <td className="w-[100px] h-[80px]">
                  <Skeleton className="w-[80px] h-full rounded-tl-md rounded-bl-md" />
                </td>
                <td className=" ">
                  <Skeleton className="w-1/2 h-4" />
                </td>
                <td className="">
                  <Skeleton className="w-1/2 h-4" />
                </td>
                <td className="">
                  <Skeleton className="w-1/2 h-4" />
                </td>
                <td className="">
                  <Skeleton className="w-1/2 h-4" />
                </td>
                <td className=" text-destructive dark:text-white">
                  <Skeleton className="w-1/2 h-4" />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
